import { render, staticRenderFns } from "./OutputCard.vue?vue&type=template&id=2288403a&scoped=true&"
import script from "./OutputCard.vue?vue&type=script&lang=js&"
export * from "./OutputCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2288403a",
  null
  
)

export default component.exports